import React from 'react'
import PropTypes from 'prop-types'
// import { Header, Footer } from 'switchboard'

const Layout = props => (
  <>
    <link
      href="https://styleguide.staging.artsmia.org/dist/css/app-2019-10-09.css"
      rel="stylesheet"
    />
    <div className="container">
      {/* <Header.withLoading /> */}
      <hr style={{ marginTop: '1em', visibility: 'hidden' }} />
      {props.children}
      {/* <Footer /> */}
    </div>
  </>
)

export default Layout

Layout.propTypes = {
  children: PropTypes.element.isRequired,
}
